module.exports = __webpack_public_path__ + "media/teams/smart-people-a6a3b58b.png";